/* tslint:disable */

declare var Object: any;
export interface TtadattstatusdetailInterface {
  "attendId": string;
  "empId": string;
  "attendDate": Date;
  "companyId": number;
  "attendCode": string;
  "remark"?: string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttadattendances?: any;
  ttadattendance?: any;
}

export class Ttadattstatusdetail implements TtadattstatusdetailInterface {
  "attendId": string;
  "empId": string;
  "attendDate": Date;
  "companyId": number;
  "attendCode": string;
  "remark": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttadattendances: any;
  ttadattendance: any;
  constructor(data?: TtadattstatusdetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadattstatusdetail`.
   */
  public static getModelName() {
    return "Ttadattstatusdetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadattstatusdetail for dynamic purposes.
  **/
  public static factory(data: TtadattstatusdetailInterface): Ttadattstatusdetail{
    return new Ttadattstatusdetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadattstatusdetail',
      plural: 'Ttadattstatusdetails',
      path: 'Ttadattstatusdetails',
      properties: {
        "attendId": {
          name: 'attendId',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "attendDate": {
          name: 'attendDate',
          type: 'Date'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "attendCode": {
          name: 'attendCode',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
        ttadattendances: {
          name: 'ttadattendances',
          type: 'any',
          model: ''
        },
        ttadattendance: {
          name: 'ttadattendance',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadattstatusdetail.ts